module.exports = __webpack_public_path__ + "static/media/top-img_9.03dd3ac0.jpg";